import React, { useState } from "react";
import { containerStyle } from "../../styles/styles";
import { TableStyles } from "../../styles/table";
import LocalBarIcon from "@material-ui/icons/LocalBar";
import { axiosInstance } from "../../../utils/axiosInstance";
import { useDispatch } from "react-redux";
import Button from "../../common/Button";
import { fetchComprehensiveCares } from "../../../store/comprehensiveCarePlan";
import ComprehensiveCostTable from "../../uis/comprehensiveCostTable/approvedTable";
import ReusableComprehensiveCostModal from "../../uis/modals/ReusableComprehensiveCostModal";

                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                
const ComprehensiveCost = () => {
  const classes = containerStyle();
  const tabClasses = TableStyles();

  const [modalConfig, setModalConfig] = useState({
    isOpen: false,
    mode: null,
    providerData: null,
  });

  const dispatch = useDispatch();

  const handleCreatePlanProvider = async (id, data) => {
    try {
      const response = await axiosInstance.post(
        `/v1/admin/cost-centres`,
        data
      );
      if (response.status) {
        dispatch(fetchComprehensiveCares(10, 1)); // Refresh table
      }
    } catch (error) {
      console.error("Error creating Optical Care plan:", error);
      throw error; // Let modal handle error
    }
  };

  const handleEditPlanProvider = async (id, data) => {
    try {
      const response = await axiosInstance.put(
        `/v1/admin/cost-centres/${id}`,
        data
      );
      console.log("Health Plan updated successfully:", response.data);
      dispatch(fetchComprehensiveCares(10, 1)); // Refresh table
    } catch (error) {
      console.error("Error updating Optical Care plan:", error);
      throw error; // Let modal handle error
    }
  };

  const openModal = (mode, providerData) => {
    setModalConfig({
      isOpen: true,
      mode,
      providerData,
    });
  };

  const closeModal = () => {
    setModalConfig({ isOpen: false, mode: null, providerData: null });
  };

  return (
    <>
      <div className={tabClasses.filterContainer}>
        <p>
          <LocalBarIcon /> Filter by:
        </p>
        <Button onClick={() => openModal("create", {})}>
          {" "}
          Create Comprehensive Cost
        </Button>
      </div>
      <div className={classes.main}>
        <div className={tabClasses.tableRoot}>
          <div className={tabClasses.tabPanelContainer}>
            <ComprehensiveCostTable
              openModal={openModal}
              closeModal={closeModal}
            />
          </div>
          <ReusableComprehensiveCostModal
            isOpen={modalConfig.isOpen}
            onClose={closeModal}
            mode={modalConfig.mode}
            providerData={modalConfig.providerData}
            onSubmit={
              modalConfig.mode === "create"
                ? handleCreatePlanProvider
                : handleEditPlanProvider
            }
          />
        </div>
      </div>
    </>
  );
};

export default ComprehensiveCost;
